import { config } from './config'

export const CONTRIBUTOR_BASE_URL = config.CONTRIBUTOR_API_ENDPOINT + config.CONTRIBUTOR_API_PATH;
export const WORKSHOP_BASE_URL = config.WORKSHOP_API_ENDPOINT;
export const WORKSHOP_AWS_KEY = config.WORKSHOP_AWS_KEY;
export const USER_UPLOAD_S3_BUCKET = config.USER_UPLOAD_S3_BUCKET;
export const TAXONOMY_BASE_URL = config.TAXONOMY_API_ENDPOINT;
